<div class="compliance">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#compliance-doc'"></app-title-page>
            </div>
            <!-- documents -->
            <div class="col-md-12 documents" id="compliance-doc">
                <div class="lane-top">
                    <div class="row mt-5">
                        <!-- Kebijikan Penerapan Tata Kelola -->
                        <div class="col-md-12">
                            <h3 class="f-subtit">{{ dataSection[0]?.title }}</h3>
                            <div class="desc mt-3 text-justify" [innerHTML]="dataSection[0]?.content"></div>
                        </div>
                        <!-- Code of Conduct -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[1]?.title }}</h3>
                            <div class="desc my-3 text-justify" [innerHTML]="dataSection[1]?.content"></div>
                            <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataEtik"></app-widget-pdf>
                        </div>
                        <!-- Board & Committee Charter -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[2]?.title }}</h3>
                            <div class="desc my-3 text-justify" [innerHTML]="dataSection[2]?.content"></div>
                            <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataBOC"></app-widget-pdf>
                        </div>
                        <!-- Internal Monitoring & Controlling System -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[3]?.title }}</h3>
                            <div class="desc my-3 text-justify" [innerHTML]="dataSection[3]?.content"></div>
                            <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataInternal"></app-widget-pdf>
                        </div>
                        <!-- Communication Policy for Shareholders or Investors -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[4]?.title }}</h3>
                            <div class="desc my-3 text-justify" [innerHTML]="dataSection[4]?.content"></div>
                            <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataCommunication"></app-widget-pdf>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
